<template>
  <div>
    <v-chart :forceFit="true" :height="height" :data="data" :padding="padding" :scale="scale">
      <v-tooltip />
      <v-axis
        :dataKey="axis1Opts.dataKey"
        :line="axis1Opts.line"
        :tickLine="axis1Opts.tickLine"
        :grid="axis1Opts.grid"
      />
      <v-axis
        :dataKey="axis2Opts.dataKey"
        :line="axis2Opts.line"
        :tickLine="axis2Opts.tickLine"
        :grid="axis2Opts.grid"
      />
      <v-legend dataKey="line" marker="circle" :offset="30" />
      <v-coord type="polar" radius="0.8" />
      <v-line position="item*score" color="line" :size="2" />
      <v-point position="item*score" color="line" :size="4" shape="circle" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

const sourceData = [
  { item: 'Design', a: 70, b: 30 },
  { item: 'Development', a: 60, b: 70 },
  { item: 'Marketing', a: 50, b: 60 },
  { item: 'Users', a: 40, b: 50 },
  { item: 'Test', a: 60, b: 70 },
  { item: 'Language', a: 70, b: 50 },
  { item: 'Technology', a: 50, b: 40 },
  { item: 'Support', a: 30, b: 40 },
  { item: 'Sales', a: 60, b: 40 },
  { item: 'UX', a: 50, b: 60 },
]

const scale = [
  {
    dataKey: 'score',
    min: 0,
    // max: 80,
  },
]

const axis1Opts = {
  dataKey: 'item',
  line: null,
  tickLine: null,
  grid: {
    lineStyle: {
      lineDash: null,
    },
    hideFirstLine: false,
  },
}
const axis2Opts = {
  dataKey: 'score',
  line: null,
  tickLine: null,
  grid: {
    type: 'polygon',
    lineStyle: {
      lineDash: null,
    },
  },
}

export default {
  name: 'Radar',
  props: {
    height: {
      type: Number,
      default: 300,
    },
    padding: {
      type: Array,
      default: () => [20, 20, 50, 20],
    },
    dataSource: {
      type: Array,
      default: () => sourceData,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    // 别名，需要的格式：[{field:'name',alias:'姓名'}, {field:'sex',alias:'性别'}]
    aliases: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      scale,
      axis1Opts,
      axis2Opts,
    }
  },
  computed: {
    data() {
      const dv = new DataSet.View().source(this.dataSource)
      dv.transform({
        type: 'fold',
        fields: this.fields,
        key: 'line',
        value: 'score',
      })
      let rows = dv.rows
      // 替换别名
      rows.forEach((row) => {
        for (let item of this.aliases) {
          if (item.field === row.line) {
            row.line = item.alias
            break
          }
        }
      })
      return rows
    },
  },
}
</script>
